import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { RoleSelection } from "@common/roleSelection";
import { Props } from "./types";
import { Columns } from "./columns";
import styles from "./styles.scss";

function Form({ formData, usedRoles, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("resourcesListingConfiguration.name")}
        </h2>
        <TextInput
          placeholder={t("resourcesListingConfiguration.name")}
          value={formData.name}
          input={(name) => edit({ ...formData, name })}
        />
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("resourcesListingConfiguration.roles")}
        </h2>
        <div className={styles.roleSelection}>
          <RoleSelection
            selectedRoleIds={formData.roles}
            rolesToExclude={usedRoles}
            placeholder={t("resourcesListingConfiguration.roles")}
            select={(role) =>
              edit({
                ...formData,
                roles: [...formData.roles, role.name],
              })
            }
            unSelect={(role) =>
              edit({
                ...formData,
                roles: formData.roles.filter(
                  (id) => id !== role.uuid && id !== role.name,
                ),
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("resourcesListingConfiguration.columns")}
        </h2>
        <Columns formData={formData} edit={edit} />
      </div>
    </div>
  );
}

export { Form };
